'use no memo';

import type { ReactElement } from 'react';

import { cn } from '@repo/lib/cn';
import { PlusIcon, Trash2Icon } from 'lucide-react';

import type { TableAddGroupItem } from '@/components/features/manage/tanstack-table/TanstackTable';

import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

interface TanstackTableActionsProps {
  addGroup?: TableAddGroupItem[];
  actionsComponent?: ReactElement;
  removeRows: () => void;
  isSelection: boolean;
}

export default function TanstackTableActions(tanstackTableActionsProps: TanstackTableActionsProps) {
  const { addGroup, removeRows, isSelection, actionsComponent } = tanstackTableActionsProps;

  let content;
  if (addGroup && addGroup.length === 1) {
    content = (
      <Button onClick={addGroup[0]?.func}>
        {addGroup[0]?.icon ? addGroup[0]?.icon : <PlusIcon />}
        <span className={'hidden md:block'}>Dodaj</span>
      </Button>
    );
  } else if (addGroup) {
    content = (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button>
            <PlusIcon />
            <span className={'hidden md:block'}>Dodaj</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align={'end'}>
          <DropdownMenuGroup>
            {addGroup.map((btn) => {
              return (
                <DropdownMenuItem key={btn.id} onClick={btn.func}>
                  {btn.icon}
                  {btn.label}
                </DropdownMenuItem>
              );
            })}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  } else if (actionsComponent) {
    content = actionsComponent;
  }

  return (
    <div className={cn('flex shrink-0 grow justify-end gap-2')}>
      <Button variant={'ghost'} variantColor={'destructive'} onClick={removeRows} disabled={!isSelection}>
        <Trash2Icon />
        <span className={'hidden md:block'}>Usuń</span>
      </Button>
      {content}
    </div>
  );
}
